import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetEnterpriseDashboardTotalViewsInterface {
  startDate: string;
  endDate: string;
  eid: string;
}

export const useGetEnterpriseDashboardTotalViews = () => {
  const mutate = useMutation(
    ({ startDate, endDate, eid }: GetEnterpriseDashboardTotalViewsInterface) => {
      return get(
        `/external-api/get_enterprise_ticket_counts_by_date_range/${eid}/${startDate}/${endDate}`,
      );
    },
  );

  return mutate;
};

export default useGetEnterpriseDashboardTotalViews;
